import { combineReducers } from 'redux';

import { appLocalStorageClear } from '../CommonFuctions/appLocalStorageClear';
import { SUCCESS } from '../Constants/commonConstants';
import { docChatReducer } from './DocChat/docChatReducer';
import { fileCompareReducer } from './FileCompare/fileCompareReducer';
// --------REDUCERS--------
import { loginReducer } from './login/loginReducer';
import { LOG_OUT } from './login/loginTypes';
import { sidebarReducer } from './sidebar/sidebarReducer';

const rootReducer = combineReducers({
  loginState: loginReducer,
  compareData: fileCompareReducer,
  docChatData: docChatReducer,
  sidebarState: sidebarReducer,
});

export const rootReducerWrapper = (state, action) => {
  if (action.type === LOG_OUT) {
    if (action.status === SUCCESS) {
      state = undefined;
      appLocalStorageClear();
    }
  }
  return rootReducer(state, action);
};
